import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PageContent.StarterGuideEmptyPopupContent', {
    buttonText: 'Set up workflow',
    title: 'No documents awaiting approval',
    description: 'Add yourself as an approver to any workflow and create a request to see how it works',
});
